import React from "react";
import { Box, Modal } from "@mui/material";
import FilterComponent from "../FilterComponent";
import { FilterComponentRef, SimpleFilterState } from "../type";
import type { ServiceLineTreeNode } from "./UnitHierarchyFilter/serviceLineTreeTypes";
import { operationsDashboardStyles } from "../styles";
interface FilterModalProps {
  open: boolean;
  onClose: () => void;
  values: SimpleFilterState;
  appliedValues: SimpleFilterState;
  businessUnits: { label: string; value: string }[];
  businessUnitsLoading: boolean;
  serviceLineOptions: { label: string; value: string }[];
  serviceLineOptionsLoading: boolean;
  serviceLineFilterTree: ServiceLineTreeNode[] | null;
  businessUnitFilterTree: ServiceLineTreeNode[] | null;
  verticalOptions: { label: string; value: string }[];
  verticalOptionsLoading: boolean;
  customerGroupOptions: { label: string; value: string }[];
  customerGroupOptionsLoading: boolean;
  customerOptions: { label: string; value: string }[];
  customerOptionsLoading: boolean;
  onAccountsChange: (values: string[]) => void;
  onCustomersChange: (values: string[]) => void;
  onVerticalsChange: (value: string) => void;
  onBusinessUnitChange: (value: string) => void;
  onServiceLineChange: (value: string) => void;
  onDateRangeChange: (start: any, end: any, label?: string) => void;
  onApply: () => void;
  onClearAll: () => void;
  userHasChanged: boolean;
}

export const FilterModal: React.FC<FilterModalProps> = ({
  open,
  onClose,
  values,
  appliedValues,
  businessUnits,
  businessUnitsLoading,
  serviceLineOptions,
  serviceLineOptionsLoading,
  serviceLineFilterTree,
  businessUnitFilterTree,
  verticalOptions,
  verticalOptionsLoading,
  customerGroupOptions,
  customerGroupOptionsLoading,
  customerOptions,
  customerOptionsLoading,
  onAccountsChange,
  onCustomersChange,
  onVerticalsChange,
  onBusinessUnitChange,
  onServiceLineChange,
  onDateRangeChange,
  onApply,
  onClearAll,
  userHasChanged,
}) => {
  const filterRef = React.useRef<FilterComponentRef>(null);

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{
        sx: operationsDashboardStyles.filterModalBackdrop,
      }}
      sx={operationsDashboardStyles.filterModal}
    >
      <Box sx={operationsDashboardStyles.filterModalContent}>
        <FilterComponent
          ref={filterRef}
          values={values}
          appliedValues={appliedValues}
          onAccountsChange={onAccountsChange}
          onCustomersChange={onCustomersChange}
          onVerticalsChange={onVerticalsChange}
          onBusinessUnitChange={onBusinessUnitChange}
          onServiceLineChange={onServiceLineChange}
          onDateRangeChange={onDateRangeChange}
          onApply={onApply}
          userHasChanged={userHasChanged}
          onClearAll={onClearAll}
          isMobile={true}
          onClose={onClose}
          businessUnits={businessUnits}
          businessUnitsLoading={businessUnitsLoading}
          serviceLineOptions={serviceLineOptions}
          serviceLineOptionsLoading={serviceLineOptionsLoading}
          serviceLineFilterTree={serviceLineFilterTree}
          businessUnitFilterTree={businessUnitFilterTree}
          verticalOptions={verticalOptions}
          verticalOptionsLoading={verticalOptionsLoading}
          customerGroupOptions={customerGroupOptions}
          customerGroupOptionsLoading={customerGroupOptionsLoading}
          customerOptions={customerOptions}
          customerOptionsLoading={customerOptionsLoading}
        />
      </Box>
    </Modal>
  );
};
